import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';

export const connectWithIntl = (...connectProps) => WrappedComponent =>
    injectIntl(connect(...connectProps)(WrappedComponent));
